import { useCallback, useRef, useState } from "react";

export interface StreakApi {
    streak: number;
    increment: () => number;
    reset: () => void;
}

export const useStreak = (): StreakApi => {
    const [streak, setStreak] = useState(0);
    const streakRef = useRef(0);

    const increment = useCallback(() => {
        streakRef.current += 1;
        setStreak(streakRef.current);
        return streakRef.current;
    }, []);

    const reset = useCallback(() => {
        streakRef.current = 0;
        setStreak(0);
    }, []);

    return { streak, increment, reset };
};
